import BaseService from "../BaseService";
import _ from "lodash";

class LoginServices extends BaseService {
    me = async () => {
        var data = await this._api.post("account/me",);
        return data;
    }




}
export default LoginServices;
